import 'jquery.easing';

export function LiffStart() {
  let indexTop = $('#indexTop').length;
  let weekTop = $('#weekTop').length;
  const resultBtn= document.getElementById('clearBtn');
  let backToTopBtn = $('#backToTopBtn');
  let clearStage;
  const BUTTON_CLICK_EVENT= document.getElementById('getWallPaperBtn');
  const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

  let ornamentClickFunc = function () {
    let scrollTop, time;
    let ornament01 = $('#ornament01');
    let ornament02 = $('#ornament02');
    let ornament03 = $('#ornament03');
    let ornament04 = $('#ornament04');
    let ornament05 = $('#ornament05');

    let ornamentClickAnimeFunc = function (url) {
      let elm = document.documentElement;
      const docHeight = elm.scrollHeight; // ページ全体の高さ
      const winHeight = elm.clientHeight;
      let bottom = docHeight - winHeight;

      if (!(scrollTop == bottom)) {
        time = 1200;
        $('body,html').animate({
          scrollTop: bottom
        }, 1500, 'easeInOutQuint');
      } else{
        time = 0;
      }
  
      wait(time)
      .then(() =>{
        $('#imgArea').addClass('big');
        return wait(200)
      })
      .then(() =>{
        $('body').addClass('big');
        $('.door').addClass('open');
        return wait(1200)
      })
      .then(() =>{
        window.location.href = url;
        return wait(1200)
      })
    }

    window.addEventListener('scroll', ()=> {
      scrollTop = $(window).scrollTop();
    });
    ornament01.on('click', function() {
      if(!$(this).hasClass('hide')){
        ornamentClickAnimeFunc('/week1.html');
      }
    });
    ornament02.on('click', function() {
      if(!$(this).hasClass('hide')){
        ornamentClickAnimeFunc('/week2.html');
      }
    });
    ornament03.on('click', function() {
      if(!$(this).hasClass('hide')){
        ornamentClickAnimeFunc('/week3.html');
      }
    });
    ornament04.on('click', function() {
      if(!$(this).hasClass('hide')){
        ornamentClickAnimeFunc('/week4.html');
      }
    });
    ornament05.on('click', function() {
      wait(0)
        .then(() =>{
          $('#modalArea').addClass('isShow');
          return wait(800)
        })
        .then(() =>{
          $('#modalArea .modalAnime').addClass('isShow');
          return wait(800)
        })
    });
  }

  let getWallPaperBtnClickFunc = function (userId) {
    BUTTON_CLICK_EVENT.addEventListener('click', () => {
      fetch('../app/send.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: userId })
      }).then(response => {
        if (response.ok) {
          //liff.closeWindow();
          $('#modalArea').removeClass('isShow');
          $('#modalArea .modalAnime').removeClass('isShow');
        } else {
          alert('特別な壁紙の受け取りに失敗しました。');
        }
      });
    });
  }

  liff.init({ liffId: "2008388345-D5vGRO55" }).then(() => {
    liff.ready.then(() => {
      //liff.logout();
      if (!liff.isLoggedIn()) {
        liff.login();
        return;
      }

      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible' && indexTop) {
          location.reload();
        }
      });
  
      const accessToken = liff.getAccessToken();
  
      const url = `https://api.line.me/oauth2/v2.1/verify?access_token=${accessToken}`;
      let userId;
  
      const browserClient = liff.isInClient();
      if(!browserClient){
        const browserErrorTxt = `LINEブラウザから閲覧してください`;
        alert(browserErrorTxt);
        $('body').addClass('browserError');
      }
  
      if (accessToken) {
        fetch(url, {
          method: 'GET',
        })
        .then(verifyResponse => {
          return fetch('https://api.line.me/v2/profile', {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${accessToken}` }
          });
        })
        .then(response => {
          if (!response.ok) {
            liff.logout();
          }
          return response.json();
        })
        .then(data => {
          userId = data.userId;
          const alertText = `こんにちは、${userId}さん！`;
          //alert(alertText);
  
          if(indexTop){
            ornamentClickFunc();
            
            let p = document.getElementById('txt');
        
            const limit1210Date = new Date('2025/12/10');
            const limit1217Date = new Date('2025/12/17');
            const limit1224Date = new Date('2025/12/24');
            let src;
            let tapSrcOrnament02 = $('#ornament02').find('.ornamentTxt').children('img').attr('src').replace('_1210_gray', '_tap');
            let tapSrcOrnament03 = $('#ornament03').find('.ornamentTxt').children('img').attr('src').replace('_1217_gray', '_tap');
            let tapSrcOrnament04 = $('#ornament04').find('.ornamentTxt').children('img').attr('src').replace('_1224_gray', '_tap');
        
            const request = new XMLHttpRequest();
        
            fetch('../app/save_user.php', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ userId: userId })
            })
            .then(response => response.json())
            .then(data => {
              let result01 = data.result_1 == 0 ? '未クリア' : 'クリア';
              let result02 = data.result_2 == 0 ? '未クリア' : 'クリア';
              let result03 = data.result_3 == 0 ? '未クリア' : 'クリア';
              let result04 = data.result_4 == 0 ? '未クリア' : 'クリア';
              //p.append('user_id : ' + data.user_id, '、クイズ1 : ' + result01, '、クイズ2 : ' + result02, '、クイズ3 : ' + result03, '、クイズ4 : ' + result04);
        
              data.result_1 == 1 ? $('#ornament01 .ornamentTxt img').attr("src", '/images/index/ornament_1203_txt.svg') && $('#ornament01').removeClass('hide tap') : $('#getOrnament01').addClass('hide');
              data.result_2 == 1 ? $('#ornament02 .ornamentTxt img').attr("src", '/images/index/ornament_1210_txt.svg') && $('#ornament02').removeClass('hide') : $('#getOrnament02').addClass('hide');
              data.result_3 == 1 ? $('#ornament03 .ornamentTxt img').attr("src", '/images/index/ornament_1217_txt.svg') && $('#ornament03').removeClass('hide') : $('#getOrnament03').addClass('hide');
              data.result_4 == 1 ? $('#ornament04 .ornamentTxt img').attr("src", '/images/index/ornament_1224_txt.svg') && $('#ornament04').removeClass('hide') : $('#getOrnament04').addClass('hide');
        
              request.open('HEAD', window.location.href, true);
              request.send();
              request.onreadystatechange = function () {
                if (this.readyState === 4) {
                  const serverDate = new Date(request.getResponseHeader('Date'));
            
                  if(serverDate > limit1210Date && data.result_1 == 1 &&  data.result_2 == 0){
                    $('#ornament02 .ornamentTxt img').attr("src", tapSrcOrnament02);
                    $('#ornament02').removeClass('hide').addClass('tap');
                    $('#getOrnament01').addClass('latest');
                  } else{
                    src = $('#ornament02').find('.ornamentTxt').children('img').attr('src').replace('_tap', '_1210');
                    $('#ornament02 .ornamentTxt img').attr("src", src);
                  }
        
                  if(serverDate > limit1217Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 0){
                    $('#ornament03 .ornamentTxt img').attr("src", tapSrcOrnament03);
                    $('#ornament03').removeClass('hide').addClass('tap');
                    $('#getOrnament02').addClass('latest');
                  } else{
                    src = $('#ornament03').find('.ornamentTxt').children('img').attr('src').replace('_tap', '_1217');
                    $('#ornament03 .ornamentTxt img').attr("src", src);
                  }
        
                  if(serverDate > limit1224Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 1 && data.result_4 == 0){
                    $('#ornament04 .ornamentTxt img').attr("src", tapSrcOrnament04);
                    $('#ornament04').removeClass('hide').addClass('tap');
                    $('#getOrnament03').addClass('latest');
                  } else{
                    src = $('#ornament04').find('.ornamentTxt').children('img').attr('src').replace('_tap', '_1224');
                    $('#ornament04 .ornamentTxt img').attr("src", src);
                  }
        
                  if(serverDate > limit1224Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 1 && data.result_4 == 1){
                    $('#ornament05').removeClass('hide')
                    $('.ornament').addClass('complete');
                    $('.scroll').addClass('complete');
                    $('#getOrnament04').addClass('latest');
                  }
        
                  if(serverDate > limit1224Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 1 && data.result_4 == 1 && data.wallpaper_dl == 0){
                    document.dispatchEvent(new CustomEvent('wallpaperDl'));
                  } else{
                    $('#modalArea').removeClass('isShow');
                    $('#modalArea .modalAnime').removeClass('isShow');
                  }
        
                }
              }
            });

            getWallPaperBtnClickFunc(userId);
          }
          if(weekTop){
            backToTopBtn.on('click', function() {
              $('.contentArea').addClass('isHidden');
              $('#weekTop').addClass('clear');
              $('#firstContentArea').addClass('isHidden');
            
              setTimeout(function(){
                window.location.href = '/?ornament=get';
              }, 1200);
            });
            resultBtn.addEventListener('click', () => {
              clearStage = resultBtn.dataset.result;
              
              fetch('../app/save_result_user.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                  userId: userId,
                  result: clearStage,
                })
              }).then(response => {
                if (response.ok) {
                  $('.contentArea').addClass('isHidden');
                  $('#weekTop').addClass('clear');
            
                  setTimeout(function(){
                    window.location.href = '/?ornament=get';
                  }, 1200);
                } else {
                  alert('送信エラー');
                }
              });
            });
          }
        });
      }
    });
  })
  .catch(err => console.error(err.message));

  // let userId = '2222';
  
  // if(indexTop){
  //   ornamentClickFunc();

  //   let p = document.getElementById('txt');

  //   const limit1210Date = new Date('2025/11/10');//2025/12/10
  //   const limit1217Date = new Date('2025/11/17');
  //   const limit1224Date = new Date('2025/11/24');
  //   let src;
  //   let tapSrcOrnament02 = $('#ornament02').find('.ornamentTxt').children('img').attr('src').replace('_1210_gray', '_tap');
  //   let tapSrcOrnament03 = $('#ornament03').find('.ornamentTxt').children('img').attr('src').replace('_1217_gray', '_tap');
  //   let tapSrcOrnament04 = $('#ornament04').find('.ornamentTxt').children('img').attr('src').replace('_1224_gray', '_tap');

  //   const request = new XMLHttpRequest();

  //   fetch('../app/save_user.php', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ userId: userId })
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     let result01 = data.result_1 == 0 ? '未クリア' : 'クリア';
  //     let result02 = data.result_2 == 0 ? '未クリア' : 'クリア';
  //     let result03 = data.result_3 == 0 ? '未クリア' : 'クリア';
  //     let result04 = data.result_4 == 0 ? '未クリア' : 'クリア';
  //     //p.append('user_id : ' + data.user_id, '、クイズ1 : ' + result01, '、クイズ2 : ' + result02, '、クイズ3 : ' + result03, '、クイズ4 : ' + result04);
  //     //console.log('user_id : ' + data.user_id, '、クイズ1 : ' + result01, '、クイズ2 : ' + result02, '、クイズ3 : ' + result03, '、クイズ4 : ' + result04, '、壁紙 : ' + data.wallpaper_dl);

  //     data.result_1 == 1 ? $('#ornament01 .ornamentTxt img').attr("src", '/images/index/ornament_1203_txt.svg') && $('#ornament01').removeClass('hide tap') : $('#getOrnament01').addClass('hide');
  //     data.result_2 == 1 ? $('#ornament02 .ornamentTxt img').attr("src", '/images/index/ornament_1210_txt.svg') && $('#ornament02').removeClass('hide') : $('#getOrnament02').addClass('hide');
  //     data.result_3 == 1 ? $('#ornament03 .ornamentTxt img').attr("src", '/images/index/ornament_1217_txt.svg') && $('#ornament03').removeClass('hide') : $('#getOrnament03').addClass('hide');
  //     data.result_4 == 1 ? $('#ornament04 .ornamentTxt img').attr("src", '/images/index/ornament_1224_txt.svg') && $('#ornament04').removeClass('hide') : $('#getOrnament04').addClass('hide');

  //     request.open('HEAD', window.location.href, true);
  //     request.send();
  //     request.onreadystatechange = function () {
  //       if (this.readyState === 4) {
  //         const serverDate = new Date(request.getResponseHeader('Date'));
    
  //         if(serverDate > limit1210Date && data.result_1 == 1 &&  data.result_2 == 0){
  //           $('#ornament02 .ornamentTxt img').attr("src", tapSrcOrnament02);
  //           $('#ornament02').removeClass('hide').addClass('tap');
  //           $('#getOrnament01').addClass('latest');
  //         } else{
  //           src = $('#ornament02').find('.ornamentTxt').children('img').attr('src').replace('_tap', '_1210');
  //           $('#ornament02 .ornamentTxt img').attr("src", src);
  //         }

  //         if(serverDate > limit1217Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 0){
  //           $('#ornament03 .ornamentTxt img').attr("src", tapSrcOrnament03);
  //           $('#ornament03').removeClass('hide').addClass('tap');
  //           $('#getOrnament02').addClass('latest');
  //         } else{
  //           src = $('#ornament03').find('.ornamentTxt').children('img').attr('src').replace('_tap', '_1217');
  //           $('#ornament03 .ornamentTxt img').attr("src", src);
  //         }

  //         if(serverDate > limit1224Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 1 && data.result_4 == 0){
  //           $('#ornament04 .ornamentTxt img').attr("src", tapSrcOrnament04);
  //           $('#ornament04').removeClass('hide').addClass('tap');
  //           $('#getOrnament03').addClass('latest');
  //         } else{
  //           src = $('#ornament04').find('.ornamentTxt').children('img').attr('src').replace('_tap', '_1224');
  //           $('#ornament04 .ornamentTxt img').attr("src", src);
  //         }

  //         if(serverDate > limit1224Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 1 && data.result_4 == 1){
  //           $('#ornament05').removeClass('hide')
  //           $('.ornament').addClass('complete');
  //           $('.scroll').addClass('complete');
  //           $('#getOrnament04').addClass('latest');
  //         }

  //         if(serverDate > limit1224Date && data.result_1 == 1 && data.result_2 == 1 && data.result_3 == 1 && data.result_4 == 1 && data.wallpaper_dl == 0){
  //           document.dispatchEvent(new CustomEvent('wallpaperDl'));
  //         } else{
  //           $('#modalArea').removeClass('isShow');
  //           $('#modalArea .modalAnime').removeClass('isShow');
  //         }

  //       }
  //     }
  //   });

  //   getWallPaperBtnClickFunc(userId);
  // }
  // if(weekTop){
  //   backToTopBtn.on('click', function() {
  //     $('.contentArea').addClass('isHidden');
  //     $('#weekTop').addClass('clear');
  //     $('#firstContentArea').addClass('isHidden');
    
  //     setTimeout(function(){
  //       window.location.href = '/?ornament=get';
  //     }, 1200);
  //   });
  //   resultBtn.addEventListener('click', () => {
  //     clearStage = resultBtn.dataset.result;
      
  //     fetch('../app/save_result_user.php', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ 
  //         userId: userId,
  //         result: clearStage,
  //       })
  //     }).then(response => {
  //       if (response.ok) {
  //         $('.contentArea').addClass('isHidden');
  //         $('#weekTop').addClass('clear');
    
  //         setTimeout(function(){
  //           window.location.href = '/?ornament=get';
  //         }, 1200);
  //       } else {
  //         alert('送信エラー');
  //       }
  //     });
  //   });
  // }
}